import { proxy, useSnapshot } from "valtio"

const store = proxy({
  activityEvent: null,
  japCustomerId: null,
  tasks: [],
  open: false
})

export const openDialog = ({ japCustomerId, activityEvent }) => {
  store.open = true
  store.activityEvent = activityEvent
  store.japCustomerId = japCustomerId
}

export const closeDialog = () => {
  store.open = false
  store.activityEvent = null
  store.japCustomerId = null
  store.tasks = []
}

export const setTasks = (tasks) => {
  store.tasks = tasks
}

export const useStore = () => {
  return useSnapshot(store)
}
